export const INITIALIZING_APP = 'INITIALIZING_APP';
export const SET_LANGUAGE = 'SET_LANGUAGE';
/************************* Spinner *************************/
export const SHOW_SPINNER = 'SHOW_SPINNER';
export const HIDE_SPINNER = 'HIDE_SPINNER';
/************************* Navbar *************************/
export const SET_NAVBAR_TITLE = 'SET_NAVBAR_TITLE';
export const CLEAR_NAVBAR_TITLE = 'CLEAR_NAVBAR_TITLE';
